'use client'

import type { MenuItem, MenuSeparator, NavGroup } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import { AppVariant, MenuActionId } from '@common/enums'

export const LAYOUT_MAIN_CONTENT_SELECTOR = '.app-layout .main-content'

export const LAYOUT_RIGHT_DRAWER_SELECTOR = '.layout-right-drawer'

export const DEFAULT_LOADER_MESSAGE = 'Loading ...'

export const ACTIVITY_LOG_ROUTES = ['/settings/project/activity-log', '/settings/team-activity'] as const

export const SCROLL_LOCK_KEY = new Set(['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '])

export const LAYOUT_DRAWER_OUTSIDE_CLICK_EXCLUSION_SELECTORS = [
  '.dialog__overlay',
  '.dialog__content',
  '[data-radix-dialog-overlay]',
  '[data-radix-dialog-content]',
  '[data-radix-popover-content]',
  '[data-radix-select-content]',
  '[data-radix-dropdown-menu-content]',
  '.select__content-wrapper',
  '.filter-dropdown',
  '.menu',
  '.menu-item',
] as const

export const MENU_ITEMS: Partial<Record<AppVariant, NavGroup[]>> = {
  portal: [
    {
      items: [
        { id: 'sidebar-dashboard', label: 'Dashboard', url: 'dashboard', icon: Icon.HomeFilled, active: true },
        {
          id: 'sidebar-service-map',
          label: 'Service map',
          url: 'service-map',
          icon: Icon.FlowchartRegular,
          active: true,
        },
        { id: 'sidebar-grafts', label: 'Grafts', url: 'grafts', icon: Icon.IotRegular, active: true },
        { id: 'sidebar-settings', label: 'Settings', url: 'settings', icon: Icon.SettingsRegular, active: true },
      ],
    },
  ],
  gateway: [
    {
      items: [
        { label: 'Gateways', url: 'gateways', icon: Icon.DSCodeGateway, active: true },
        { label: 'Favorite gateways', url: 'gateways', icon: Icon.StarRegular, disabled: true },
      ],
    },
  ],
  vision: [
    {
      items: [
        { label: 'Overview', url: 'vision', icon: Icon.AppsRegular, active: true },
        { label: 'Pipelines', url: 'pipelines', icon: Icon.FlowchartRegular, disabled: true },
        { label: 'Settings', url: 'settings', icon: Icon.SettingsRegular, disabled: true },
      ],
    },
  ],
  modules: [
    {
      items: [
        {
          id: 'sidebar-modules-search',
          label: 'Search modules',
          url: '',
          icon: Icon.SearchRegular,
          active: true,
        },
        {
          id: 'sidebar-modules-installed',
          label: 'Installed modules',
          url: 'installed-modules',
          icon: Icon.ArrowDownloadRegular,
          active: true,
        },
        {
          id: 'sidebar-modules-favourite',
          label: 'Favourite modules',
          url: 'favourite-modules',
          icon: Icon.StarRegular,
          active: true,
        },
        {
          id: 'sidebar-modules-vulnerabilities',
          label: 'Vulnerabilities',
          url: 'vulnerabilities',
          icon: Icon.ShieldRegular,
          active: true,
        },
      ],
    },
  ],
  conference: [
    {
      items: [{ label: 'Conference', url: 'conference', icon: Icon.GCConference, active: true }],
    },
  ],
} as const

export const ADD_NEW_ITEMS: (MenuItem | MenuSeparator)[] = [
  {
    type: 'item',
    active: true,
    groups: [],
    label: 'Add service',
    icon: Icon.StorageRegular,
    id: MenuActionId.ADD_NEW_SERVICE,
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.FolderRegular,
    label: 'Add project',
    id: MenuActionId.ADD_NEW_PROJECT,
  },
  {
    type: 'item',
    active: true,
    groups: [],
    icon: Icon.OrganizationHorizontalRegular,
    label: 'Add Workspace',
    id: MenuActionId.ADD_NEW_WORKSPACE,
  },
] as const
